import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";

interface IProps {
    open: boolean;
    singleData: any;
    onClose: () => void;
    toast: any;
}

export const Sub_ECI = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Consultant_Mast/getConsultantSubmissionDetails", "GET", null, `consultant_ID=${props.singleData.consultant_ID}`, props.toast);
        if (response) {
            const data: any[] = await response.json();
            setTableData({ tableData: data, loading: false });
        }
        else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const subDate = (rowData: any) => {
        let date;
        if (rowData.subDateTime) date = format(new Date(rowData.subDateTime), 'dd/MM/yyyy HH:mm').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onClose = () => {
        props.onClose();
    }

    useEffect(() => {
        if (props.open && props.singleData.consultant_ID) {
            loadTableData();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Consultant Submission Details" modal className="p-fluid" onHide={onClose}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="consultant_ID"
                emptyMessage="No Details found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_ID" header="Con.ID" />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="req_ID" header="Req ID" />
                <Column field="req_Job_Title" header="Job Title" />
                {/* <Column field="vendor_Company_Name" header="Vendor Company Name" /> */}
                <Column field="sales" header="Sales" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="subDateTime" header="SubDateTime" body={subDate} />
                <Column field="status" header="Status" />
            </DataTable>
        </Dialog>
    );
}